import { render, staticRenderFns } from "./siteForm.vue?vue&type=template&id=06b791da&scoped=true&"
import script from "./siteForm.vue?vue&type=script&lang=js&"
export * from "./siteForm.vue?vue&type=script&lang=js&"
import style0 from "./siteForm.vue?vue&type=style&index=0&id=06b791da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b791da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06b791da')) {
      api.createRecord('06b791da', component.options)
    } else {
      api.reload('06b791da', component.options)
    }
    module.hot.accept("./siteForm.vue?vue&type=template&id=06b791da&scoped=true&", function () {
      api.rerender('06b791da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/partner/tab/siteForm.vue"
export default component.exports